import React, { useEffect, useState } from "react";
import HeaderBar from "../../../components/header/headerBar";
import Input from "../../../components/textfield/input";
import MainButton from "../../../components/button/mainButton";
import Textarea from "../../../components/textfield/textarea";
import { useParams } from "react-router-dom";
import CheckboxText from "../../../components/textfield/checkbox";
import styled from 'styled-components'
import "../../../assets/styles/admin/stock.scss";
import {
  CheckBox,
  CheckBox2,
  RadioField,
  TextBox,
} from "../../../components/textfield";
import {
  Space,
  Checkbox,
  Row,
  Col,
  Form,
  DatePicker,
  Button,
  Typography,
  Upload,
  InputNumber,
  message,
  Select,
} from "antd";
import { Icon } from "@iconify/react";
import { useHistory } from "react-router-dom";
import axios from "axios";
interface ParamsType {
  id: string;
}

const AddProduct = () => {
  const history = useHistory();
  const { id } = useParams<ParamsType>();
  const { Option } = Select;
  const [branch, setBranch] = useState<string>("");
  const [wareHouse, setWareHouse] = useState<string>("");
  const [typeOrder, setTypeOrder] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [bigUnits, setBigUnits] = useState<string>("");
  const [subUnit, setSubUnit] = useState<string>("");
  const [amountPer, setAmountPer] = useState<string>("");
  const [pricePerUnit, setPricePerUnit] = useState<string>("");
  const [expirationDate, setExpirationDate] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [codeOrder, setCodeOrder] = useState<string>("");
  const [remainingAlert, setRemainingAlert] = useState<string>("");
  const [notifiExpire, setNotifiExpire] = useState<string>("");
  const [amountSubUnit, setAmountSubUnit] = useState<string>("");
  const [productType, setProductType] = useState<any>([]);
  const [units, setUnits] = useState<any>([]);
  const [supplier, setSupplier] = useState<any>([]);
  const [data, setData] = useState<any>({
    "isRemindExpirationDate": false,
    "totalPricePerUnit": 0,
    "totalPricePerSubUnit": 0,
    "totalPricePerSubUnit2": 0,
    "isRemainingAlert": false,
    "code": "",
    "name": "",
    "stockCategory": '',
    "expirationDate": '',
    "remindExpirationDate": 0,
    "unit": '',
    "subUnit": '',
    "subUnit2": '',
    "averagePricePerSubUnit": 0,
    "averagePricePerSubUnit2": 0,
    "remainingAlert": 0,
    "details": "",
    "supplier": "",
    "prices": [
      {
        isActived: false,
        amount: 0
      },
      {
        isActived: false,
        amount: 0
      },
      {
        isActived: false,
        amount: 0
      }
    ]
  });
  const updateData = (id: string) => {
    axios.patch(`/stock-products/update/${id}`, data).then((res) => {
      if (res.status === 200)
        history.goBack()
    });
  };

  useEffect(() => {
    getProductType();
    getUnits();
    getSupplier()
  }, []);
  useEffect(() => {
    getData();
  }, [id]);
  const getData = () => {
    axios.get(`/stock-products/${id}`).then((res) => {
      setData(res?.data?.data);
    });
  };
  const getProductType = () => {
    axios.get(`/stock-categories`).then((res) => {
      setProductType(res?.data?.data.map((item: any, index: number) => {
        return {
          value: item?._id,
          name: item?.name
        }
      }))
    });
  };
  const getUnits = () => {
    axios.get(`/stock-product-units`).then((res) => {
      setUnits(res?.data?.data.map((item: any, index: number) => {
        return {
          value: item?._id,
          name: item?.name
        }
      }))
    });
  };
  const getSupplier = () => {
    axios.get(`/supplier`).then((res) => {
      setSupplier(res?.data?.data.map((item: any, index: number) => {
        return {
          value: item?._id,
          label: item?.supplierName
        }
      }))
    });
  };

  const [personnelType, setPersonnelType] = useState<any>([]);
  const [name, setName] = useState("");
  const onNameChange = (e: any) => {
    setName(e.target.value);
  };
  const StyleForm = styled.div`
    .ant-form-item-label 
    {
      width: 100%;
      label {
        text-align: left;
        width: 100%;
        position: relative;
        display: inline-flex;
        align-items: center;
        max-width: 100%;
        height: 32px;
        color: #5baea9;
        font-size: 14px;
      }
    }

  `
  const ChangRender = styled.div`

`
  const NumberFormat = (number: number = 0) => {
    try {
      let str_number = number.toFixed(2)
      let split_number = str_number.split(".")
      return new Intl.NumberFormat().format(number) + `.${split_number[1]}`;
    } catch (error) {
      let str = number.toString();
      let str_number = parseFloat(str).toFixed(2)
      let split_number = str_number.split(".")
      return new Intl.NumberFormat().format(split_number.length > 0 ? parseFloat(split_number[0]) : number) + `.${split_number[1]}`;
    }
  }
  const onSave = () => {
    axios.post(`/stock-products`, data).then((res) => {
      if (res.status === 200)
        history.goBack()
    });
  }

  return (
    <div>
      <HeaderBar title={(id) ? "Inventory Management/Edit Product" : "Inventory Management/Add Product"} btnBack={true} />

      <div style={{ margin: "0px 40px" }}>
        <div className="create-page" style={{ padding: "20px 40px" }}>
          <div className="title-header">
            {
              (id) ?
                <h3 style={{ fontSize: "20px" }}>แก้ไขสินค้า/Edit Product</h3>
                :
                <h3 style={{ fontSize: "20px" }}>เพิ่มสินค้า/Add Product</h3>
            }

          </div>
          <div className="row justify-content-around">
            <div className="row">
              <div className="row col-4 ">
                <div className="col-6 mt-2">
                  <ChangRender>
                    <div
                      style={{
                        color: "#5BAEA9",
                        marginBottom: 5,
                        fontSize: 14,
                        fontWeight: 500,
                      }}
                    >
                      ประเภท/Category
                    </div>
                    <Form.Item
                      name="Category"
                    >

                      <Select
                        className="antd-Selected"
                        showSearch
                        suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                        defaultValue={data.stockCategory}
                        onChange={(val: string) => setData({ ...data, stockCategory: val })}
                      >
                        {productType.map((province: any) => (
                          <Option key={province} value={province.value}>{province?.name}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </ChangRender>
                </div>
                <Input
                  className="col-5 mt-2"
                  title="รหัสสินค้า/Code"
                  type="text"
                  placeholder=""
                  value={data.code}
                  onChange={(e: any) => setData({ ...data, code: e.target.value })}
                />
              </div>
              <div className="row col-8">
                <Input
                  className="col-12"
                  title="ชื่อการค้า/Trade Name"
                  type="text"
                  placeholder=""
                  value={data.nameTrade}
                  onChange={(e) => {
                    setData({ ...data, nameTrade: e.target.value })
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="row col-4">
                <Input
                  className="col-11"
                  title="รหัสคลินิก/Clinic Code"
                  type="text"
                  placeholder=""
                  value={data.codeClinic}
                  onChange={(e) => setData({ ...data, codeClinic: e.target.value })}
                />
              </div>
              <div className="row col-8">
                <Input
                  className="col-12"
                  title="ชื่อสามัญ/Common Name"
                  type="text"
                  placeholder=""
                  value={data.name}
                  onChange={(e) => setData({ ...data, name: e.target.value })}
                />
              </div>
            </div>
            <div className="row">
              <div className="row col-4">
              </div>
              <div className="row col-8">
                <div className="input col-12" style={{ height: "auto" }}>
                  <div className="title-input">ผู้ผลิต/Supplier</div>
                </div>
                <Select
                  className="antd-Selected"
                  showSearch
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  defaultValue={data.supplier}
                  onChange={(val: string) => setData({ ...data, supplier: val })}
                  options={supplier}
                />
              </div>
            </div>
            <div className="row">
              {
                data?.prices?.map((item: any, index: number) => {
                  return (
                    <div className="row col-4" key={index}>
                      <div className="row">
                        <div className="col-1">
                          <RadioField
                            title=""
                            name="flexRadioDefault"
                            id="1"
                            onClick={() => {
                              let mapData = data?.prices?.map((kitem: any, kindex: number) => {
                                return {
                                  ...kitem,
                                  isActived: index === kindex ? true : false
                                }
                              })
                              setData({ ...data, prices: mapData });
                            }}
                            isChecked={item?.isActived}
                          />
                        </div>
                        <div className="col-10">
                          <Input
                            title={`ราคา ${index + 1}/Price ${index + 1}`}
                            onChange={(e) => {
                              item.amount = e.target.value;
                              setData({ ...data });
                            }}
                            inputStyle={{
                              borderBottom: "2px solid #d3d8dd",
                              padding: "1px 2px"
                            }}
                            customText={NumberFormat(item?.amount)}
                          />

                        </div>
                      </div>
                    </div>
                  )
                }
                )
              }
            </div>
          </div>
          <div className="row justify-content-around mt-4 pt-2 pb-4" style={{
            border: '1px solid #D3D8DD',
            borderRadius: '1rem'
          }}>
            <div className="col-12">
              <div className="row">
                <div className="row col-4">
                  <div className="col-11">
                    <ChangRender>
                      <div
                        style={{
                          color: "#5BAEA9",
                          marginBottom: 5,
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                      >
                        หน่วยใหญ่/Unit
                      </div>
                      <Form.Item
                        name="Category"
                      >
                        <Select
                          className="antd-Selected"
                          showSearch
                          suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                          defaultValue={data?.unit}
                          onChange={(value: string) => setData({ ...data, unit: value })}
                        >
                          <Option value=""> </Option>
                          {units.map((province: any) => (
                            <Option key={province} value={province?.value}>{province?.name}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </ChangRender>
                  </div>
                </div>
                <div className="row col-4">
                  <Input
                    className="col-12 mt-2"
                    title="จำนวนทั้งหมดต่อหน่วยใหญ่/Total price per unit"
                    value={data.totalPricePerUnit}
                    onChange={(e) => setData({ ...data, totalPricePerUnit: e.target.value })}
                    inputStyle={{
                      borderBottom: "2px solid #d3d8dd",
                      padding: "1px 2px"
                    }}
                    customText={NumberFormat(data.totalPricePerUnit)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="row col-4">
                  <div className="col-11">
                    <ChangRender>
                      <div
                        style={{
                          color: "#5BAEA9",
                          marginBottom: 5,
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                      >
                        หน่วยย่อย/Sub Unit
                      </div>
                      <Form.Item
                        name="Category"
                      >
                        <Select
                          className="antd-Selected"
                          showSearch
                          suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                          defaultValue={data?.subUnit}
                          onChange={(value: string) => setData({ ...data, subUnit: value })}
                        >
                          <Option value=""> </Option>
                          {units.map((province: any) => (
                            <Option key={province} value={province?.value}>{province?.name}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </ChangRender>
                  </div>
                </div>
                <div className="row col-4">
                  <Input
                    className="col-12 mt-2"
                    title="จำนวนทั้งหมดต่อหน่วยย่อย/Total price per Sub Unit"
                    value={data.totalPricePerSubUnit}
                    onChange={(e) => setData({ ...data, totalPricePerSubUnit: e.target.value })}
                    inputStyle={{
                      borderBottom: "2px solid #d3d8dd",
                      padding: "1px 2px"
                    }}
                    customText={NumberFormat(data.totalPricePerSubUnit)}
                  />
                </div>
                <div className="row col-4">
                  <Input
                    className="col-12 mt-2"
                    title="ราคาเฉลี่ยต่อหน่วยย่อย/Average price per Sub Unit"
                    type="text"
                    value={data.averagePricePerSubUnit}
                    onChange={(e) => setData({ ...data, averagePricePerSubUnit: e.target.value })}
                    inputStyle={{
                      borderBottom: "2px solid #d3d8dd",
                      padding: "1px 2px"
                    }}
                    customText={NumberFormat(data.averagePricePerSubUnit)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="row col-4">
                  <div className="col-11">
                    <ChangRender>
                      <div
                        style={{
                          color: "#5BAEA9",
                          marginBottom: 5,
                          fontSize: 14,
                          fontWeight: 500,
                        }}
                      >
                        หน่วยย่อย/Sub Unit2
                      </div>
                      <Form.Item
                        name="Category"
                      >
                        <Select
                          className="antd-Selected"
                          showSearch
                          suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                          defaultValue={data?.subUnit2}
                          onChange={(value: string) => setData({ ...data, subUnit2: value })}
                        >
                          <Option value=""> </Option>
                          {units.map((province: any) => (
                            <Option key={province} value={province?.value}>{province?.name}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </ChangRender>
                  </div>
                </div>
                <div className="row col-4">
                  <Input
                    className="col-12 mt-2"
                    title="จำนวนทั้งหมดต่อหน่วยย่อย2/Total price per Sub Unit2"
                    type="text"
                    value={data.totalPricePerSubUnit2}
                    onChange={(e) => {
                      setData({ ...data, totalPricePerSubUnit2: e.target.value });
                    }}
                    inputStyle={{
                      borderBottom: "2px solid #d3d8dd",
                      padding: "1px 2px"
                    }}
                    customText={NumberFormat(data.totalPricePerSubUnit2)}
                  />
                </div>
                <div className="row col-4">
                  <Input
                    className="col-12 mt-2"
                    title="ราคาเฉลี่ยต่อหน่วยย่อย/Average price per Sub Unit 2"
                    type="text"
                    value={data.averagePricePerSubUnit2}
                    onChange={(e) => {
                      setData({ ...data, averagePricePerSubUnit2: e.target.value });
                    }}
                    inputStyle={{
                      borderBottom: "2px solid #d3d8dd",
                      padding: "1px 2px"
                    }}
                    customText={NumberFormat(data.averagePricePerSubUnit2)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-around">
            <div className="row">
              <div className="row col-4">
                <div className="input mt-2">
                  <div className="title-input">แจ้งเตือนเมื่อเหลือ (จำนวน/หน่วยย่อย2)/Notification</div>
                  <div className="check-box ">
                    <input type="checkbox" style={{
                      marginRight: '1rem',
                      border: '1px solid #EBEFF2'
                    }} className="form-check-input" onChange={(e) => {
                      setData({ ...data, isRemindExpirationDate: e.target.checked })
                    }}
                      checked={data.isRemindExpirationDate}
                    />
                    <input type="number" placeholder="" onChange={(e) => {
                      setData({ ...data, remindExpirationDate: e.target.value })
                    }} value={data.remindExpirationDate} />
                  </div>
                </div>
              </div>
              <div className="row col-4">
                <div className="input mt-2">
                  <div className="title-input">แจ้งเตือนก่อนหมดอายุ (วัน)/Alert Expire</div>
                  <div className="check-box ">
                    <input type="checkbox" style={{
                      marginRight: '1rem',
                      border: '1px solid #EBEFF2'
                    }} className="form-check-input"
                      onChange={(e) => {
                        setData({ ...data, isRemainingAlert: e.target.checked })
                      }}
                      checked={data.isRemainingAlert}
                    />
                    <input type="number" placeholder="" onChange={(e) => {
                      setData({ ...data, remainingAlert: e.target.value })
                    }} value={data.remainingAlert} />
                  </div>
                </div>
              </div>
              <div className="row col-4">
              </div>
            </div>
            <div className="row">
              <Textarea
                title="รายละเอียด/Details"
                placeholder=""
                value={data.details}
                onChange={(e) => {
                  setData({ ...data, details: e.target.value })
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="justify-center mt-20">
        <MainButton className="mg-10" background="#E76464" title="ยกเลิก/Cancel" />
        <MainButton
          className="mg-10"
          title="บันทึกข้อมูล/Submit"
          onClick={() => {
            id ? updateData(id) : onSave();
          }}
        />
      </div>
    </div>
  );
};
export default AddProduct;
